import { render, staticRenderFns } from "./NavigationDesktopAboutus.vue?vue&type=template&id=36c437fa"
import script from "./NavigationDesktopAboutus.vue?vue&type=script&lang=ts"
export * from "./NavigationDesktopAboutus.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NavigationLinkText: require('/codebuild/output/src1993466134/src/acredo-website/components/navigation/NavigationLinkText.vue').default})
